<template>
<vs-button block transparent class="plan" :active="active" :disabled="disabled" @click="$emit('click')">
    <div class="details">
        <img src="../../assets/icons/subscription.png" />
        <div class="info">
            <p>{{ plan.name }}</p>
            <span style="background: rgba(var(--vs-primary),0.8); color: white; font-weight: 500;  padding: 5px; border-radius: 5px; font-size: 0.8rem;" v-if="plan.not_purchasable === true">NON PIÙ DISPONIBILE</span>
        </div>
    </div>
    <div class="price">
        <p :style="{'text-decoration': discountedPrice != null ? 'line-through' : 'none'}" style="font-weight: 600; font-size: 1.25rem;">{{ (plan.price/100).toFixed(2) }}€</p>
        <p v-if="discountedPrice != null" style="color: rgba(var(--vs-primary)); font-weight: bold; font-size: 1.5rem;"> {{ discountedPrice }}€</p>
    </div>
</vs-button>
</template>

<script>
export default {
    name: "planCard",
    props: {
        plan: {
            type: Object,
            required: true
        },
        discountedPrice: {
            type: [String, Number],
            default: null
        },
        active: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>
.plan .vs-button__content {
    padding:0!important;
    justify-content: space-between;
}
</style>
<style scoped>
p {
    margin: 0;
}

.plan {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    gap: 10px;
    border: 1px solid var(--primary);
    border-radius: 10px;
    margin: 0!important;
}

.plan .details {
    display: flex;
    align-items: center;
    gap: 10px;
}

.plan .details .info {
    display: flex;
    flex-direction: column;
}

.plan .details .info p {
    text-align: left;
}

.plan .details .info p:nth-child(1) {
    color: var(--primary) !important;
    font-size: 1.1rem;
}

.plan .price {
    display: flex;
    flex-direction: column;
}

.plan .price p:nth-child(2) {
    font-size: 0.8rem;
    font-weight: 400;
    color: var(--grey-75);
}
</style>
